/**
 * 날짜를 YYYY-MM-DD 형식으로 변환
 * @param value 입력된 날짜 문자열 (e.g., 2024-12-24T17:21:09.792944)
 * @returns 포맷팅된 날짜 문자열 (YYYY-MM-DD)
 */
export const formatDate = (value: string): string => {
  // 유효성 검사를 위해 Date 객체 생성
  const date = new Date(value);

  // 유효하지 않은 날짜 문자열 처리
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date format');
  }

  // 연도, 월, 일 추출
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월(1~12) 보정
  const day = String(date.getDate()).padStart(2, '0');

  // YYYY-MM-DD 형식 반환
  return `${year}-${month}-${day}`;
};
